import { Building2, LayoutDashboard, Menu, Settings, UserCog, Users, Laptop } from "lucide-react";
import { memo, useState } from "react";

type SidebarProps = {
    onCurrentTab: (value: number) => void;
    tab: number;
};

const menuItems = [
    { name: 'Dashboard', icon: LayoutDashboard, value: 1 },
    { name: 'Thông tin trung tâm', icon: Building2, value: 2 },
    { name: 'Học sinh', icon: Users, value: 3 },
    { name: 'Nhân Viên', icon: UserCog, value: 4 },
    { name: 'Thuê Laptop', icon: Laptop, value: 5 },
    // { name: 'Admin', icon: UserCog, value: 5 },
    { name: 'Cài đặt', icon: Settings, value: 7 }
];

function Sidebar({ onCurrentTab, tab }: SidebarProps) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    return (
        <div className={`${sidebarCollapsed ? 'w-20' : 'w-80'} bg-slate-900/50 backdrop-blur-sm border-r border-slate-700/50 transition-all duration-300 p-4`}>
            <div className="flex items-center justify-between mb-8">
                <h1 className={`text-white font-bold text-xl ${sidebarCollapsed ? 'hidden' : 'block'}`}>Admin</h1>
                <button onClick={() => setSidebarCollapsed(!sidebarCollapsed)} className="text-slate-400 hover:text-white">
                    <Menu size={24} />
                </button>
            </div>

            <nav className="space-y-2">
                {menuItems.map((item, idx) => {
                    const Icon = item.icon;
                    return (
                        <div onClick={() => onCurrentTab(item.value)} key={idx} className={`flex items-center gap-3 text-slate-300 hover:text-white hover:bg-slate-800/50 ${item.value === tab ? 'bg-black' : ''} p-3 rounded-lg cursor-pointer transition-all`}>
                            <Icon size={20} className="flex-shrink-0 mr-[10px]" />
                            <span className={sidebarCollapsed ? 'hidden' : 'block'}>{item.name}</span>
                        </div>
                    );
                })}
            </nav>
        </div>
    );
}

export default memo(Sidebar);